import { Table } from "@chakra-ui/react";
import { Cell, Row, flexRender } from "@tanstack/react-table";
import { Fragment, useCallback } from "react";
import ClaimsDetails from "./ClaimsDetails";
import { ClaimsItemDto } from "@/api/claimsApi";

type ClaimsTableRowProps = {
    row: Row<ClaimsItemDto>;
};

const ClaimsTableRow = ({ row }: ClaimsTableRowProps) => {
    const handleKeyUp = useCallback(
        (e: React.KeyboardEvent<HTMLTableRowElement>) => {
            if (e.key === "Enter") {
                row.getToggleExpandedHandler()();
            }
        },
        [row]
    );

    const handleOnClick = useCallback(() => {
        if (!globalThis.getSelection()?.toString()) {
            row.getToggleExpandedHandler()();
        }
    }, [row]);

    const handleBackgroundColor = (cell: Cell<ClaimsItemDto, unknown>) =>
        cell.getContext().column.getIsSorted() || row.getIsExpanded() ? "anchor.brown.100" : {};

    return (
        <Fragment key={row.id}>
            <Table.Row
                id={"claimsTableRow" + row.id}
                onClick={handleOnClick}
                _hover={{
                    cursor: "pointer",
                    backgroundColor: "anchor.brown.50"
                }}
                tabIndex={0}
                onKeyUp={handleKeyUp}
                maxW="100%"
            >
                {/* first row is a normal row */}
                {row.getVisibleCells().map(cell => {
                    return (
                        <Table.Cell
                            key={cell.id}
                            whiteSpace="nowrap"
                            textOverflow="ellipsis"
                            backgroundColor={handleBackgroundColor(cell)}
                            fontSize={"16px"}
                            wordBreak="break-word"
                        >
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </Table.Cell>
                    );
                })}
            </Table.Row>
            {row.getIsExpanded() && (
                <Table.Row>
                    {/* 2nd row is a custom 1 cell row */}
                    <Table.Cell colSpan={row.getVisibleCells().length} p="0" maxW="100%">
                        <ClaimsDetails claimsId={row.getValue("id")} />
                    </Table.Cell>
                </Table.Row>
            )}
        </Fragment>
    );
};

export default ClaimsTableRow;
